import { commentAdapter } from '@/Module/Comment/Store/Adapter';
import type { IState } from '@/Module/Store/Model';

export const {
  selectIds: commentSelectIds,
  selectById: commentSelectById,
  selectTotal: commentSelectTotal,
} = commentAdapter.getSelectors<IState>(state => state.comment);
